/**
 * 「公式サンプル」タグ。
 * 一覧の公式サンプルタブは廃止済み（アセット自体は通常のアニメーションレコードとして残っている）。
 * このタグ自体は、一般ユーザーが公式を騙って同名タグを付けられないようにするための
 * なりすまし防止目的の予約タグとして残している（管理者以外は付与不可。Upload.tsx / backend の
 * createAnimation・updateAnimation を参照）。
 */
export const OFFICIAL_TAG = '公式サンプル';
